export default __webpack_public_path__ + "static/media/Active.9ff97055.png";